import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';
// import packageJson from 'package.json';
import App from './App';
import i18n from 'i18n-js';
import { Translations } from './shared/translations'

import monstersReducer from './store/reducers/monstersReducer';
import buildingsReducer from './store/reducers/buildingsReducer'

i18n.translations = Translations;

const availableLanguages = ['en', 'es', 'it', 'fr', 'de', 'ja', 'zh', 'ko']
const userLanguage = window.navigator.language?.split('-')[0]
const matchedLanguage = availableLanguages.find(el => el === userLanguage)
const finalLanguage = localStorage.getItem('EHPLanguage') || matchedLanguage || 'en'

i18n.locale = finalLanguage;

const rootReducer = combineReducers({
  monsters: monstersReducer,
  buildings: buildingsReducer
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

// CLEAR PREVIOUS LOCALSTORAGE
const version = process.env.REACT_APP_VERSION
if (!localStorage.getItem(version) || parseInt(localStorage.getItem(version)) < parseInt(version)) {
  localStorage.setItem('EHPVersion', version)
  localStorage.removeItem('EHPBuildings')
}

ReactDOM.render(
  <Provider store={store}>
    <App language={finalLanguage} />
  </Provider>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
